import { render, staticRenderFns } from "./LightBannerCookie.vue?vue&type=template&id=58e0f88a&scoped=true"
import script from "./LightBannerCookie.vue?vue&type=script&lang=js"
export * from "./LightBannerCookie.vue?vue&type=script&lang=js"
import style0 from "./LightBannerCookie.vue?vue&type=style&index=0&id=58e0f88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e0f88a",
  null
  
)

export default component.exports